import { APP_INITIALIZER } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { BasePortalSettingsService } from '../../core/services/base-portal-settings.service';
import { PortalService } from '../../../api';
import { PortalSettings } from '../../core/types/base-portal-settings.type';

export function portalSettingsInitializerFactory(
  configService: BasePortalSettingsService,
  portalService: PortalService
) {
  return () =>
    firstValueFrom(portalService.getPortalSettingShow()).then((response) => {
      configService.setSettings(response.data as PortalSettings);
    });
}

export const PORTAL_SETTINGS_INITIALIZER_PROVIDER = {
  provide: APP_INITIALIZER,
  useFactory: portalSettingsInitializerFactory,
  deps: [BasePortalSettingsService, PortalService],
  multi: true,
};
